import React from 'react';
import { Link } from 'react-router-dom';

const TermsPage: React.FC = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      <div className="bg-gradient-to-r from-[#0A0A0A] to-[#1a1a2e] text-white py-10 sm:py-14">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <h1 className="text-3xl sm:text-4xl font-black">📜 Kullanım Koşulları</h1>
          <p className="text-gray-400 mt-2">Son güncelleme: 28 Temmuz 2026</p>
        </div>
      </div>

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="bg-white rounded-2xl border border-gray-100 p-6 sm:p-10 space-y-8">
          
          <section>
            <h2 className="text-xl font-bold text-gray-800 mb-3">1. Kabul</h2>
            <p className="text-sm text-gray-600 leading-relaxed">
              Bu web sitesini (traxcarcareproducts.com) kullanarak, bu Kullanım Koşullarını kabul etmiş 
              sayılırsınız. Bu koşulları kabul etmiyorsanız, lütfen sitemizi kullanmayın.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-gray-800 mb-3">2. Hizmet Tanımı</h2>
            <p className="text-sm text-gray-600 leading-relaxed">
              T-RaX Car Care, oto bakım ürünleri satışı yapan bir e-ticaret platformudur. 
              Hizmetlerimiz arasında ürün satışı, kargo takip ve müşteri desteği bulunmaktadır.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-gray-800 mb-3">3. Üyelik</h2>
            <p className="text-sm text-gray-600 leading-relaxed mb-3">
              Sitemizden alışveriş yapmak için üyelik gereklidir. Üyelik bilgilerinizin doğru ve güncel 
              olması sorumluluğunuzdadır. Hesap güvenliğinizden siz sorumlusunuzdur.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-gray-800 mb-3">4. Sipariş ve Ödeme</h2>
            <ul className="list-disc list-inside text-sm text-gray-600 space-y-2 ml-4">
              <li>Tüm fiyatlar Türk Lirası (₺) cinsindendir ve KDV dahildir</li>
              <li>Ödemeler Paytr 3D Secure sistemi ile güvenli şekilde işlenir</li>
              <li>Sipariş onayı, e-posta ile bildirilir</li>
              <li>Stok tükenmesi durumunda sipariş iptal edilir ve ödeme iade edilir</li>
              <li>1000 TL ve üzeri alışverişlerde ücretsiz kargo uygulanır</li>
              <li>Kargo ücreti 129 TL'dir</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-bold text-gray-800 mb-3">5. Kargo ve Teslimat</h2>
            <p className="text-sm text-gray-600 leading-relaxed">
              Siparişleriniz, ödeme onayından sonra en geç 3 iş günü içinde kargoya verilir. 
              Kargo takip numarası e-posta ile bildirilir. Teslimat süreleri kargo şirketinin 
              yoğunluğuna göre değişiklik gösterebilir.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-gray-800 mb-3">6. İade ve İptal</h2>
            <ul className="list-disc list-inside text-sm text-gray-600 space-y-2 ml-4">
              <li>Ürünü teslim aldığınız tarihten itibaren 14 gün içinde iade edebilirsiniz</li>
              <li>İade edilecek ürünün kullanılmamış ve orijinal ambalajında olması gerekir</li>
              <li>Kargo masrafları müşteriye aittir (hatalı/hasarlı ürünler hariç)</li>
              <li>İade talepleri kargo takip sayfasından yapılabilir</li>
              <li>İade onayından sonra ödeme 5-10 iş günü içinde iade edilir</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-bold text-gray-800 mb-3">7. Fikri Mülkiyet</h2>
            <p className="text-sm text-gray-600 leading-relaxed">
              Sitedeki tüm içerik (metin, görsel, logo, tasarım) T-RaX Car Care'a aittir ve 
              telif hakkı ile korunur. İzinsiz kopyalanması, çoğaltılması veya kullanılması yasaktır.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-gray-800 mb-3">8. Sorumluluk Sınırlılığı</h2>
            <p className="text-sm text-gray-600 leading-relaxed">
              T-RaX Car Care, sitedeki bilgilerin doğruluğunu garanti etmez. Ürün görselleri 
              gerçeğiyle ufak farklılıklar gösterebilir. Sitenin kesintisiz çalışacağı garanti edilmez.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-gray-800 mb-3">9. Değişiklikler</h2>
            <p className="text-sm text-gray-600 leading-relaxed">
              Bu koşullar zaman zaman güncellenebilir. Güncellemeler sitede yayınlandığı anda 
              yürürlüğe girer. Önemli değişiklikler e-posta ile bildirilir.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-gray-800 mb-3">10. Uyuşmazlıklar</h2>
            <p className="text-sm text-gray-600 leading-relaxed">
              Bu koşullardan doğan uyuşmazlıklarda Ankara mahkemeleri ve icra daireleri yetkilidir.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-gray-800 mb-3">11. İletişim</h2>
            <div className="text-sm text-gray-600 space-y-1">
              <p><strong>Şirket:</strong> T-RaX Car Care (SBT Kimya)</p>
              <p><strong>Adres:</strong> Yeni Birlik Sanayi Sitesi, Saray, 675. Cadde No:24/12, 06980 Kahramankazan/Ankara</p>
              <p><strong>E-posta:</strong> <a href="mailto:info@sbtkimya.com.tr" className="text-[#E31E24] hover:underline">info@sbtkimya.com.tr</a></p>
              <p><strong>Telefon:</strong> 0312 815 11 65</p>
            </div>
          </section>
        </div>

        <div className="mt-8 text-center">
          <Link to="/" className="text-sm text-[#E31E24] hover:underline font-medium">
            ← Ana Sayfaya Dön
          </Link>
        </div>
      </div>
    </div>
  );
};

export default TermsPage;
